<template>
  <div
    class="tw-flex tw-flex-col"
    @click="handleClick"
  >
    <div class="tw-flex tw-justify-between tw-items-center tw-py-1 tw-cursor-pointer">
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <span class="tw-leading-5 tw-text-dark tw-tracking-wider tw-font-medium">
          {{ permit.permit_type_name }}
        </span>
        <span class="tw-leading-5 tw-text-gray-dark">
          {{ permit.reference_number }}
        </span>
      </div>
      <icon-angle-right class="tw-text-primary" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForeignersNewThreadItem',
  props: {
    permit: {
      type: Object,
      required: true,
    },
    foreigner: {
      type: Object,
      default: null,
    },
    storePath: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$store.dispatch(`${this.storePath}/openNewThread`, { permit: this.permit, foreigner: this.foreigner });
      this.$emit('new-thread');
    },
  },
};
</script>
